// extracted by mini-css-extract-plugin
module.exports = {"container":"RequiredDocuments_container__25vaZ","sectionTitle":"RequiredDocuments_sectionTitle__2t7Ny"};